import { Children } from 'react';

function getStringFromReactNode (reactNode) {
  var stringNodes = Children.toArray(reactNode).filter(function (i) {
    return typeof i === 'string';
  });
  return stringNodes.reduce(function (acc, cur) {
    return "".concat(acc, " ").concat(cur).trim();
  }, '');
}

export default getStringFromReactNode;
//# sourceMappingURL=get-string-from-react-node.esm.js.map
